import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { GA4_APP_PLAY_GAME_EVENT } from "@/feature-analytics/google.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";

export async function onEnterEftGame(payload) {
  refs.gtag("event", GA4_APP_PLAY_GAME_EVENT, {
    ...(await refs.getIdentifyingInfo()),
    game: "eft",
  });

  return refs.trackEvent(ANALYTIC_EVENTS.EFT_START, payload);
}

export function onExitEftGame(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.EFT_END, payload);
}
